export default "__VITE_ASSET__529b86a2__"